export { default } from "./CartTypeLabel";
